import { Icon } from "@material-ui/core";
import React, { CSSProperties, MouseEventHandler, TouchEventHandler } from "react";
import styles from "./HorizontalCard.scss";

interface IProps {
    id?: string;
    editButtonId?: string;
    children?: React.ReactNode[] | React.ReactNode;
    onClick?: MouseEventHandler;
    onClickEdit?: MouseEventHandler;
    className?: string;
    onMouseDown?: MouseEventHandler;
    onTouchStart?: TouchEventHandler;
    style?: CSSProperties;
}

const HorizontalCard: React.FunctionComponent<IProps> = (props: IProps) => (
    <div
        id={props.id}
        className={`${styles.stepBlockWrapper} ${props.onClick ? styles.withLink : null}`}
        onClick={props.onClick}
        onMouseDown={props.onMouseDown}
        onTouchStart={props.onTouchStart}
        style={props.style}>
        <div className={`${props.className} ${styles.stepBlock} ${styles.shadow}`} >
            {props.onClickEdit ? <span id={props.editButtonId} onClick={props.onClickEdit} className={styles.editIcon}><Icon>edit</Icon></span> : null}
            {props.children}
        </div>
    </div>
);

export default HorizontalCard;


// WEBPACK FOOTER //
// ./src/Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCard.tsx